// extracted by mini-css-extract-plugin
export default {"tooltip-wrapper":"tooltip-wrapper__104M9","tooltip-tip":"tooltip-tip__yWy4Q","arrow":"arrow__4BYmZ","top":"top__8ouLb","showing":"showing__fBP9Q"};